import { QUIET_ACTION_FLAG } from "../lib/base/actions";
const defaultPredicate = (state, action) => {
    // we ignore "quiet" actions in the devtools log
    return !(action.meta && action.meta[QUIET_ACTION_FLAG]);
};
export default defaultPredicate;
